(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["easy-video-home"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('deseo-video-reel')) return;

    const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    class DeseoVideoReel extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;

        this.ac = new AbortController();
        this.viewport = this.querySelector('[data-viewport]');
        this.track = this.querySelector('[data-track]');
        if (!this.viewport || !this.track) return;

        /* Movimento reduzido: sem esteira automática, vira modo arrastar */
        this.mode = this.dataset.mode === 'drag' || reduceMotion() ? 'drag' : 'auto';
        this.dataset.mode = this.mode;

        this.originals = Array.from(this.track.children).filter((el) => !el.hasAttribute('data-clone'));
        try {
          this.items = JSON.parse(this.querySelector('[data-items]').textContent);
        } catch (e) {
          this.items = [];
        }

        this.dotsWrap = this.querySelector('[data-dots]');
        this.dots = this.dotsWrap ? Array.from(this.dotsWrap.querySelectorAll('button')) : [];
        this.activeDot = -1;
        this.moved = false;

        this.setupVideos();
        if (this.mode === 'auto') this.setupAuto();
        else this.setupDrag();
        this.setupDots();
        this.setupPopup();

        this.resizeObserver = new ResizeObserver(() => {
          clearTimeout(this.resizeTimer);
          this.resizeTimer = setTimeout(() => this.onResize(), 120);
        });
        this.resizeObserver.observe(this.viewport);
      }

      disconnectedCallback() {
        this._ready = false;
        if (this.ac) this.ac.abort();
        this.stopLoop();
        cancelAnimationFrame(this.tweenRaf);
        cancelAnimationFrame(this.momentumRaf);
        cancelAnimationFrame(this.scrollRaf);
        clearTimeout(this.resumeTimer);
        clearTimeout(this.resizeTimer);
        if (this.videoObserver) this.videoObserver.disconnect();
        if (this.sectionObserver) this.sectionObserver.disconnect();
        if (this.resizeObserver) this.resizeObserver.disconnect();
        if (this.modalOpen) this.closePopup();
        if (this.track) {
          this.track.querySelectorAll('[data-clone]').forEach((n) => n.remove());
          this.track.style.transform = '';
        }
      }

      get signal() {
        return this.ac.signal;
      }

      /* ───── Vídeos dos cards: tocam só quando aparecem na tela ───── */
      setupVideos() {
        this.videoObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const video = entry.target;
              if (entry.isIntersecting && !this.modalOpen && !reduceMotion()) {
                video.play().catch(() => {});
              } else {
                video.pause();
              }
            });
          },
          { rootMargin: '0px 200px', threshold: 0.01 }
        );
        this.observeVideos();
      }

      observeVideos() {
        this.track.querySelectorAll('video').forEach((video) => {
          video.muted = true;
          this.videoObserver.unobserve(video);
          this.videoObserver.observe(video);
        });
      }

      pauseVideos() {
        this.track.querySelectorAll('video').forEach((video) => video.pause());
      }

      /* ───── Modo automático (esteira infinita) ───── */
      setupAuto() {
        const signal = this.signal;
        this.offset = 0;
        this.speed = parseFloat(this.dataset.speed) || 40;
        this.direction = this.dataset.direction === 'right' ? 1 : -1;
        this.paused = false;
        this.hovering = false;
        this.dragging = false;

        this.buildClones();

        if (this.dataset.pauseHover === 'true') {
          this.viewport.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') this.hovering = true; }, { signal });
          this.viewport.addEventListener('pointerleave', (e) => { if (e.pointerType === 'mouse') this.hovering = false; }, { signal });
        }

        this.viewport.addEventListener('pointerdown', (e) => {
          if (e.pointerType === 'mouse' && e.button !== 0) return;
          cancelAnimationFrame(this.tweenRaf);
          this.dragging = true;
          this.moved = false;
          this.dragStartX = e.clientX;
          this.dragStartOffset = this.offset;
          this.viewport.classList.add('is-dragging');
        }, { signal });

        window.addEventListener('pointermove', (e) => {
          if (!this.dragging) return;
          const dx = e.clientX - this.dragStartX;
          if (Math.abs(dx) > 6) this.moved = true;
          this.offset = this.dragStartOffset + dx;
          this.applyOffset();
        }, { signal, passive: true });

        const end = () => {
          if (!this.dragging) return;
          this.dragging = false;
          this.viewport.classList.remove('is-dragging');
          this.pauseFor(this.moved ? 2500 : 1200);
        };
        window.addEventListener('pointerup', end, { signal });
        window.addEventListener('pointercancel', end, { signal });
        this.viewport.addEventListener('dragstart', (e) => e.preventDefault(), { signal });

        this.sectionObserver = new IntersectionObserver((entries) => {
          this.inView = entries[0].isIntersecting;
          if (this.inView) this.startLoop();
          else this.stopLoop();
        });
        this.sectionObserver.observe(this);
      }

      buildClones() {
        this.track.querySelectorAll('[data-clone]').forEach((n) => n.remove());
        this.measure();
        const copies = Math.ceil(this.viewport.clientWidth / Math.max(this.loopWidth, 1)) + 1;
        for (let n = 0; n < copies; n++) {
          this.originals.forEach((el) => {
            const clone = el.cloneNode(true);
            clone.setAttribute('data-clone', '');
            clone.setAttribute('aria-hidden', 'true');
            clone.setAttribute('tabindex', '-1');
            clone.removeAttribute('id');
            clone.removeAttribute('data-shopify-editor-block');
            this.track.appendChild(clone);
          });
        }
        this.observeVideos();
      }

      measure() {
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        let x = 0;
        this.cardStarts = [];
        this.cardSpans = [];
        this.originals.forEach((el) => {
          const span = el.getBoundingClientRect().width + gap;
          this.cardStarts.push(x);
          this.cardSpans.push(span);
          x += span;
        });
        this.loopWidth = x;
      }

      startLoop() {
        if (this.raf || this.mode !== 'auto') return;
        let last = null;
        const step = (t) => {
          this.raf = requestAnimationFrame(step);
          if (last === null) { last = t; return; }
          const dt = Math.min(64, t - last) / 1000;
          last = t;
          if (this.paused || this.hovering || this.dragging || this.modalOpen || document.hidden) return;
          this.offset += this.direction * this.speed * dt;
          this.applyOffset();
        };
        this.raf = requestAnimationFrame(step);
      }

      stopLoop() {
        if (this.raf) cancelAnimationFrame(this.raf);
        this.raf = null;
      }

      applyOffset() {
        const w = this.loopWidth || 1;
        this.offset = ((this.offset % w) - w) % w;
        this.track.style.transform = `translate3d(${this.offset}px, 0, 0)`;
        this.syncDotsFromOffset();
      }

      pauseFor(ms) {
        this.paused = true;
        clearTimeout(this.resumeTimer);
        this.resumeTimer = setTimeout(() => { this.paused = false; }, ms);
      }

      /* ───── Modo arrastar (swipe no celular, arrastar com mouse no desktop) ───── */
      setupDrag() {
        const signal = this.signal;

        this.viewport.addEventListener('pointerdown', (e) => {
          if (e.pointerType !== 'mouse' || e.button !== 0) return;
          cancelAnimationFrame(this.momentumRaf);
          this.dragging = true;
          this.moved = false;
          this.dragStartX = e.clientX;
          this.dragStartScroll = this.viewport.scrollLeft;
          this.velocity = 0;
          this.lastX = e.clientX;
          this.lastT = performance.now();
          this.viewport.classList.add('is-dragging');
          e.preventDefault();
        }, { signal });

        window.addEventListener('pointermove', (e) => {
          if (!this.dragging) return;
          const dx = e.clientX - this.dragStartX;
          if (Math.abs(dx) > 6) this.moved = true;
          this.viewport.scrollLeft = this.dragStartScroll - dx;
          const now = performance.now();
          if (now > this.lastT) this.velocity = (e.clientX - this.lastX) / (now - this.lastT);
          this.lastX = e.clientX;
          this.lastT = now;
        }, { signal, passive: true });

        const end = () => {
          if (!this.dragging) return;
          this.dragging = false;
          let v = this.velocity * 16;
          const decay = () => {
            if (Math.abs(v) < 0.5) {
              this.viewport.classList.remove('is-dragging');
              this.scrollToIndex(this.nearestIndex());
              return;
            }
            this.viewport.scrollLeft -= v;
            v *= 0.92;
            this.momentumRaf = requestAnimationFrame(decay);
          };
          decay();
        };
        window.addEventListener('pointerup', end, { signal });
        window.addEventListener('pointercancel', end, { signal });
        this.viewport.addEventListener('dragstart', (e) => e.preventDefault(), { signal });

        this.viewport.addEventListener('scroll', () => {
          if (this.scrollRaf) return;
          this.scrollRaf = requestAnimationFrame(() => {
            this.scrollRaf = null;
            this.syncFromScroll();
          });
        }, { signal, passive: true });

        this.prevBtn = this.querySelector('[data-prev]');
        this.nextBtn = this.querySelector('[data-next]');
        if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.scrollToIndex(this.nearestIndex() - 1), { signal });
        if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.scrollToIndex(this.nearestIndex() + 1), { signal });

        this.computeReachable();
        this.syncFromScroll();
      }

      trackPad() {
        return parseFloat(getComputedStyle(this.track).paddingLeft) || 0;
      }

      nearestIndex() {
        const target = this.viewport.scrollLeft + this.trackPad();
        let best = 0;
        let bestD = Infinity;
        this.originals.forEach((card, k) => {
          const d = Math.abs(card.offsetLeft - target);
          if (d < bestD) { bestD = d; best = k; }
        });
        return best;
      }

      scrollToIndex(i) {
        const k = Math.max(0, Math.min(this.lastReachable ?? this.originals.length - 1, i));
        const card = this.originals[k];
        if (!card) return;
        this.viewport.scrollTo({ left: card.offsetLeft - this.trackPad(), behavior: reduceMotion() ? 'auto' : 'smooth' });
      }

      computeReachable() {
        const max = this.viewport.scrollWidth - this.viewport.clientWidth;
        const pad = this.trackPad();
        let last = this.originals.length - 1;
        for (let k = 0; k < this.originals.length; k++) {
          if (this.originals[k].offsetLeft - pad >= max - 1) { last = k; break; }
        }
        this.lastReachable = last;
        this.dots.forEach((dot, k) => { dot.hidden = k > last; });
        if (this.dotsWrap) this.dotsWrap.classList.toggle('is-hidden', max <= 1);
        const arrows = this.querySelector('.dvr__arrows');
        if (arrows) arrows.style.visibility = max <= 1 ? 'hidden' : '';
      }

      syncFromScroll() {
        const max = this.viewport.scrollWidth - this.viewport.clientWidth;
        let i = this.nearestIndex();
        if (max > 1 && this.viewport.scrollLeft >= max - 2) i = this.lastReachable;
        i = Math.min(i, this.lastReachable ?? i);
        this.setDot(i, 1);
        if (this.prevBtn) this.prevBtn.disabled = this.viewport.scrollLeft <= 2;
        if (this.nextBtn) this.nextBtn.disabled = this.viewport.scrollLeft >= max - 2;
      }

      /* ───── Pontos de navegação ───── */
      setupDots() {
        if (!this.dotsWrap || this.dots.length !== this.originals.length) {
          this.dots = [];
          return;
        }
        const signal = this.signal;
        this.dotsWrap.addEventListener('click', (e) => {
          const dot = e.target.closest('button');
          if (dot) this.goTo(parseInt(dot.dataset.index, 10));
        }, { signal });

        this.dotsWrap.addEventListener('keydown', (e) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(e.key)) return;
          const visible = this.dots.filter((d) => !d.hidden);
          const current = visible.indexOf(e.target.closest('button'));
          if (current < 0) return;
          e.preventDefault();
          let next = current;
          if (e.key === 'ArrowRight') next = (current + 1) % visible.length;
          else if (e.key === 'ArrowLeft') next = (current - 1 + visible.length) % visible.length;
          else if (e.key === 'Home') next = 0;
          else next = visible.length - 1;
          visible[next].focus();
          this.goTo(parseInt(visible[next].dataset.index, 10));
        }, { signal });

        this.setDot(0, this.mode === 'drag' ? 1 : 0);
      }

      setDot(i, progress) {
        if (!this.dots.length) return;
        if (i !== this.activeDot) {
          const prev = this.dots[this.activeDot];
          if (prev) {
            prev.removeAttribute('aria-current');
            prev.style.removeProperty('--p');
          }
          this.activeDot = i;
          this.lastProgress = -1;
          if (this.dots[i]) this.dots[i].setAttribute('aria-current', 'true');
        }
        const p = Math.max(0, Math.min(1, progress));
        if (Math.abs(p - this.lastProgress) > 0.004 && this.dots[i]) {
          this.lastProgress = p;
          this.dots[i].style.setProperty('--p', p.toFixed(3));
        }
      }

      syncDotsFromOffset() {
        if (!this.dots.length || !this.cardStarts) return;
        const pos = -this.offset;
        let i = this.cardStarts.length - 1;
        for (let k = 1; k < this.cardStarts.length; k++) {
          if (pos < this.cardStarts[k]) { i = k - 1; break; }
        }
        let frac = (pos - this.cardStarts[i]) / (this.cardSpans[i] || 1);
        if (this.direction === 1) frac = 1 - frac;
        this.setDot(i, frac);
      }

      goTo(i) {
        if (i < 0 || i >= this.originals.length) return;
        if (this.mode === 'drag') {
          this.scrollToIndex(i);
          return;
        }
        const w = this.loopWidth || 1;
        let delta = -this.cardStarts[i] - this.offset;
        if (delta > w / 2) delta -= w;
        else if (delta < -w / 2) delta += w;
        this.paused = true;
        clearTimeout(this.resumeTimer);
        cancelAnimationFrame(this.tweenRaf);
        const from = this.offset;
        const duration = reduceMotion() ? 0 : Math.min(900, 350 + Math.abs(delta) * 0.35);
        const start = performance.now();
        const tick = (now) => {
          const t = duration ? Math.min(1, (now - start) / duration) : 1;
          this.offset = from + delta * (1 - Math.pow(1 - t, 3));
          this.applyOffset();
          if (t < 1) this.tweenRaf = requestAnimationFrame(tick);
          else this.pauseFor(3000);
        };
        this.tweenRaf = requestAnimationFrame(tick);
      }

      onResize() {
        if (!this._ready) return;
        if (this.mode === 'auto') {
          this.buildClones();
          this.applyOffset();
        } else {
          this.computeReachable();
          this.syncFromScroll();
        }
      }

      /* ───── Popup estilo stories ───── */
      setupPopup() {
        this.dialog = this.querySelector('dialog');
        if (!this.dialog) return;
        const signal = this.signal;
        const d = this.dialog;

        this.playable = this.items.map((item, i) => Object.assign({}, item, { i })).filter((item) => item.src);
        if (!this.playable.length) return;

        this.modalVideo = d.querySelector('[data-video]');
        this.muteBtn = d.querySelector('[data-mute]');
        this.barsWrap = d.querySelector('[data-bars]');
        this.barsWrap.innerHTML = this.playable.map(() => '<span><i></i></span>').join('');
        this.bars = Array.from(this.barsWrap.children);

        const openFromCard = (card) => {
          if (!card || !card.hasAttribute('data-clickable') || this.moved) return;
          this.openPopup(parseInt(card.dataset.index, 10), card);
        };
        this.track.addEventListener('click', (e) => openFromCard(e.target.closest('[data-card]')), { signal });
        this.track.addEventListener('keydown', (e) => {
          if (e.key !== 'Enter' && e.key !== ' ') return;
          const card = e.target.closest('[data-card]');
          if (!card) return;
          e.preventDefault();
          openFromCard(card);
        }, { signal });
        /* Um novo toque zera o "arrastou" para o clique seguinte funcionar */
        this.viewport.addEventListener('pointerdown', () => { if (this.mode === 'drag') this.moved = false; }, { signal, capture: true });

        d.querySelectorAll('[data-close]').forEach((btn) => btn.addEventListener('click', () => this.closePopup(), { signal }));
        d.querySelectorAll('[data-go]').forEach((btn) => btn.addEventListener('click', () => this.showPopup(this.pos + parseInt(btn.dataset.go, 10)), { signal }));
        d.addEventListener('click', (e) => { if (e.target === d) this.closePopup(); }, { signal });
        d.addEventListener('cancel', (e) => { e.preventDefault(); this.closePopup(); }, { signal });
        d.addEventListener('close', () => this.closePopup(), { signal });
        d.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight') this.showPopup(this.pos + 1);
          else if (e.key === 'ArrowLeft') this.showPopup(this.pos - 1);
          else if (e.key === 'm' || e.key === 'M') this.toggleMute();
        }, { signal });

        this.muteBtn.addEventListener('click', () => this.toggleMute(), { signal });
        this.modalVideo.addEventListener('click', () => {
          if (this.modalVideo.paused) this.modalVideo.play().catch(() => {});
          else this.modalVideo.pause();
        }, { signal });
        this.modalVideo.addEventListener('timeupdate', () => {
          const bar = this.bars[this.pos];
          if (!bar || !this.modalVideo.duration) return;
          bar.firstElementChild.style.width = (this.modalVideo.currentTime / this.modalVideo.duration) * 100 + '%';
        }, { signal });
        this.modalVideo.addEventListener('ended', () => this.showPopup(this.pos + 1), { signal });

        let startX = 0;
        let startY = 0;
        d.addEventListener('touchstart', (e) => {
          startX = e.touches[0].clientX;
          startY = e.touches[0].clientY;
        }, { signal, passive: true });
        d.addEventListener('touchend', (e) => {
          const dx = e.changedTouches[0].clientX - startX;
          const dy = e.changedTouches[0].clientY - startY;
          if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) this.showPopup(this.pos + (dx < 0 ? 1 : -1));
          else if (dy > 90 && Math.abs(dy) > Math.abs(dx)) this.closePopup();
        }, { signal, passive: true });
      }

      toggleMute() {
        this.modalVideo.muted = !this.modalVideo.muted;
        this.muteBtn.classList.toggle('is-muted', this.modalVideo.muted);
        this.muteBtn.setAttribute('aria-pressed', String(this.modalVideo.muted));
      }

      openPopup(index, trigger) {
        const pos = this.playable.findIndex((item) => item.i === index);
        if (pos < 0) return;
        this.modalOpen = true;
        this.openedIndex = index;
        this.lastFocus = trigger || document.activeElement;
        this.pauseVideos();
        document.documentElement.classList.add('dvr-lock');
        if (!this.dialog.open) this.dialog.showModal();
        this.modalVideo.muted = false;
        this.muteBtn.classList.remove('is-muted');
        this.muteBtn.setAttribute('aria-pressed', 'false');
        this.showPopup(pos);
        this.dialog.querySelector('[data-close]').focus();
      }

      showPopup(pos) {
        if (!this.modalOpen) return;
        const total = this.playable.length;
        this.pos = (pos + total) % total;
        const item = this.playable[this.pos];
        const d = this.dialog;

        this.bars.forEach((bar, k) => { bar.firstElementChild.style.width = k < this.pos ? '100%' : '0'; });
        d.querySelector('[data-counter]').textContent = `${this.pos + 1} / ${total}`;

        const avatar = d.querySelector('[data-avatar]');
        if (item.avatar) { avatar.src = item.avatar; avatar.parentElement.hidden = false; }
        else { avatar.parentElement.hidden = true; }
        d.querySelector('[data-handle]').textContent = item.handle || '';
        d.querySelector('[data-badge]').hidden = !item.handle;
        d.querySelector('[data-quote]').textContent = item.quote || '';
        const views = d.querySelector('[data-views]');
        views.textContent = item.views || '';
        views.hidden = !item.views;

        const product = d.querySelector('[data-product]');
        if (item.product) {
          product.hidden = false;
          product.href = item.product.url;
          d.querySelector('[data-product-title]').textContent = item.product.title;
          d.querySelector('[data-product-price]').textContent = item.product.price;
          d.querySelector('[data-product-cta]').textContent = item.product.label;
          const img = d.querySelector('[data-product-image]');
          if (item.product.image) { img.src = item.product.image; img.hidden = false; }
          else img.hidden = true;
        } else {
          product.hidden = true;
        }

        if (item.poster) this.modalVideo.poster = item.poster;
        else this.modalVideo.removeAttribute('poster');
        this.modalVideo.src = item.src;
        const playing = this.modalVideo.play();
        if (playing) {
          playing.catch(() => {
            /* Navegador bloqueou som automático: toca sem som e mostra o botão de som desligado */
            this.modalVideo.muted = true;
            this.muteBtn.classList.add('is-muted');
            this.muteBtn.setAttribute('aria-pressed', 'true');
            this.modalVideo.play().catch(() => {});
          });
        }
      }

      closePopup() {
        if (!this.modalOpen) return;
        this.modalOpen = false;
        this.modalVideo.pause();
        this.modalVideo.removeAttribute('src');
        this.modalVideo.load();
        if (this.dialog.open) this.dialog.close();
        document.documentElement.classList.remove('dvr-lock');
        this.observeVideos();

        /* Se a pessoa navegou para outro vídeo no popup, a faixa acompanha */
        const viewed = this.playable[this.pos];
        if (viewed && viewed.i !== this.openedIndex) this.goTo(viewed.i);
        else if (this.mode === 'auto') this.pauseFor(600);

        if (this.lastFocus && this.lastFocus.isConnected) this.lastFocus.focus({ preventScroll: true });
      }
    }

    customElements.define('deseo-video-reel', DeseoVideoReel);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
